export default __webpack_public_path__ + "static/media/nepal_onshore_wind.92ae3838.png";